
import React from "react";
import "./BenefitsContact.css";
import phone from "../../images/phone.svg"

const contacts = [
    {
        title: "Rede de Saúde Montepio - Portugal",
        phone: "707 102 121",
        description:
            "Atendimento personalizado dias úteis das 08h30 às 18h30. Custo de chamada pela rede fixa de 0,09€/min +IVA, ou por rede móvel de 0,13€/min + IVA."
    },
    {
        title: "Rede de Saúde Montepio - Estrangeiro",
        phone: "+351 210 142 121",
        description:
            "Atendimento personalizado dias úteis das 08h30 às 18h30. Custo de chamada para a rede fixa nacional."
    }
];

export default function BenefitsContact() {
    return (
        <section className="benefits-contact">
            <h2 className="benefits-contact__heading">
                Um leque de vantagens à sua disposição
            </h2>

            <div className="benefits-contact__card">
                {contacts.map((contact) => (
                    <article
                        className="benefits-contact__item"
                        key={contact.phone}
                    >
                        <h3 className="benefits-contact__title">
                            {contact.title}
                        </h3>

                        <a
                            className="benefits-contact__phone"
                            href={`tel:${contact.phone.replace(/\s/g, "")}`}
                        >
                            <img src={phone} alt="phone" />
                            <span>{contact.phone}</span>
                        </a>

                        <p className="benefits-contact__description">
                            {contact.description}
                        </p>
                    </article>
                ))}
            </div>
        </section>
    );
}
